import React from 'react';
import { useTranslation } from 'react-i18next';
import { ShiurDay } from '../../utils/shiurTimes';
import { dayOfWeekOf } from '../../utils/openingHours';
import ShiurTimeText from './ShiurTimeText';
import { specialDayLabel } from './WeekHours';

/** A shiur's next days, like the opening-hours week. Days with nothing and no reason are left out. */
export default function ShiurWeek({ days }: { days: ShiurDay[] }) {
  const { t, i18n } = useTranslation();
  const lang = i18n.language === 'he' ? 'he' : 'en';
  const shown = days.filter((d, i) => i === 0 || d.occurrences.length > 0 || d.noShiurReason);
  if (!days.some((d) => d.occurrences.length > 0 || d.noShiurReason)) {
    return <p className="text-sm text-ash">{t('directory.shiur.show.noShiurThisWeek')}</p>;
  }

  return (
    <ul className="divide-y divide-ink/5">
      {shown.map((day) => {
        const isToday = day.date === days[0].date;
        const special = specialDayLabel(day, lang);
        return (
          <li key={day.date} className={`flex items-start justify-between gap-3 py-2 text-sm ${isToday ? 'font-semibold' : ''}`}>
            <span className="text-ink shrink-0">
              {isToday ? t('directory.detail.today') : t(`directory.dayOfWeek.${dayOfWeekOf(day.date)}`)}
              {special && <span className="block text-xs text-ash font-normal">{special}</span>}
            </span>
            <span className="text-end text-ink">
              {day.occurrences.length > 0 ? (
                day.occurrences.map((o) => <ShiurTimeText key={`${o.sessionId}-${o.start}`} occurrence={o} />)
              ) : day.noShiurReason ? (
                <span className="text-ash">{t(`directory.shiur.show.noShiur.${day.noShiurReason}`)}</span>
              ) : (
                <span className="text-ash">–</span>
              )}
            </span>
          </li>
        );
      })}
    </ul>
  );
}
